package one.healthium.domain.paywall.models

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonNames

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@SerialName("other_plans")
data class PaywallOtherPlansView(
    @JsonNames("id") override val id: String,
    @SerialName("config") val config: OtherPlansConfig,
) : PaywallScreenView

@Serializable
data class OtherPlansConfig(
    @SerialName("button") val button: String? = null,
    @SerialName("title") val title: String? = null,
    @SerialName("plans") val plans: List<ProductControl> = emptyList(),
)
